numberUtil = exports

numberUtil.comparator = (a, b) ->
    return a - b

numberUtil.isSet = (val) ->
    return ( !!val or val is 0 )

numberUtil.notSet = (val) ->
    return not numberUtil.isSet(val)
